import { SupplierRegistrationCountryFields } from '@supplierRegistration/domain/supplierRegistrationCountryFields';

enum PolandLegalIdTypesForCompany {
  VAT = 'VAT',
  Other = 'Other',
}

export const PL: SupplierRegistrationCountryFields = {
  leis: { types: PolandLegalIdTypesForCompany },
};
